import { createContext, useContext, useState, ReactNode } from 'react';

interface NavbarContextType {
  hideNav: boolean;
  setHideNav: (value: boolean) => void;
  activeHomeSection: number | null;
  setActiveHomeSection: (section: number | null) => void;
  goToVideoSection: (() => void) | null;
  setGoToVideoSection: (callback: (() => void) | null) => void;
  goToPortfolioSection: (() => void) | null;
  setGoToPortfolioSection: (callback: (() => void) | null) => void;
}

const NavbarContext = createContext<NavbarContextType | undefined>(undefined);

export const useNavbar = (): NavbarContextType => {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error('useNavbar must be used within NavbarProvider');
  }
  return context;
};

interface NavbarProviderProps {
  children: ReactNode;
}

export const NavbarProvider = ({ children }: NavbarProviderProps) => {
  const [hideNav, setHideNav] = useState(false);
  const [activeHomeSection, setActiveHomeSection] = useState<number | null>(null);
  const [goToVideoSection, setGoToVideoSection] = useState<(() => void) | null>(null);
  const [goToPortfolioSection, setGoToPortfolioSection] = useState<(() => void) | null>(null);

  return (
    <NavbarContext.Provider value={{
      hideNav,
      setHideNav,
      activeHomeSection,
      setActiveHomeSection,
      goToVideoSection,
      setGoToVideoSection,
      goToPortfolioSection,
      setGoToPortfolioSection
    }}>
      {children}
    </NavbarContext.Provider>
  );
};
